const m = window.require("discourse/lib/body-scroll-lock");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;